import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useToastr } from '../widgets/ToastrContext';
import { useInvalidateRegisterHistory } from '../hooks/useRegisterHistory';
import { useInvalidateRegisterLogs } from '../hooks/useRegisterLogs';
import { useInvalidateSiteLogs } from '../hooks/useSiteLogs';
import { useInvalidateSignInLocations } from '../hooks/useSignInLocation';
const withRouter = Component => props => {
  const location = useLocation();
  const navigate = useNavigate();
  const params = useParams();
  const toastr = useToastr();
  const invalidateRegisterHistory = useInvalidateRegisterHistory();
  const invalidateRegisterLogs = useInvalidateRegisterLogs();
  const invalidateSiteLogs = useInvalidateSiteLogs();
  const invalidateSignInLocations = useInvalidateSignInLocations();

  return (
    <Component
      {...props}
      location={location}
      navigate={navigate}
      toastr={toastr}
      params={params}
      invalidateRegisterHistory={invalidateRegisterHistory}
      invalidateRegisterLogs={invalidateRegisterLogs}
      invalidateSiteLogs={invalidateSiteLogs}
      invalidateSignInLocations={invalidateSignInLocations}
    />
  );
};

export default withRouter;